module.exports = __webpack_public_path__ + "static/media/loader.409c18a1.svg";